<template>
  <div class="loginInputWrapper">
    <span>{{spanText}}</span>
    <div class="loginInputTextWrapper">
      <input v-bind:type="isPassword ? 'password' : 'text'" v-bind:placeholder="placeHolder" v-on:keyup="returnText" v-on:keyup.enter="pressEnterKey"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    spanText: String,
    placeHolder: String,
    isPassword: Boolean
  },
  methods: {
    returnText: function (e) {
      this.$emit('returnText', e.target.value)
    },
    pressEnterKey: function () {
      this.$emit('pressEnterKey')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
span{
  color: rgb(0,153,255);
}

.loginInputWrapper{
  font-size: 11px;
  margin-top: 25px;
}

.loginInputTextWrapper{
  width: 396px;
  padding-top: 25px;
  padding-bottom: 10px;
}

input[type='text'], input[type='password'] {
  padding-bottom: 5px;
  font-size: 18px;
  width: 100%;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px rgb(112,112,112) solid;
}

input[type='text']:focus, input[type='password']:focus{
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/login/elements/loginInputText.vue